import { useState, useContext } from 'react';

import UIContext from 'components/Utils/UIContext';
import { MaskableComponent } from 'components/Tutorial/MaskableComponent';

import './SideMenu.sass';
import { compact, isFunction } from 'lodash';
import { Layout } from 'antd';

export const SideMenu = ({ tabs, children, defaultTab }) => {
    const uiContext = useContext(UIContext);
    const [selectedTab, setSelectedTab] = useState<string>(defaultTab);

    const availableTabs = compact(tabs)
    let effectiveTab = selectedTab;
    const hasSelectedTab = availableTabs.find((t) => t.id == selectedTab);
    if (!hasSelectedTab) {
        effectiveTab = defaultTab;
    }



    return <MaskableComponent masked={uiContext.maskedZones['sidemenu']}>
        <Layout.Sider
            // 300px
            width={300}
            id="SideMenu"
            style={{
                borderLeft: 'var(--ant-line-width) var(--ant-line-type) var(--ant-color-border-secondary)',
                width: "300px"
            }}
            className={
                'SideMenu opened'
            }
        >
            <ul className="VerticalTabs noselection ant-tabs-nav-list">

                {availableTabs.map((t, index) => {
                    return (
                        <li
                            key={index}
                            onClick={() => {
                                setSelectedTab(t.id);
                            }}
                            data-testid={`sidemenu-tab-${t.id}`}
                            className={[
                                "ant-tabs-tab",
                                t.id,
                                effectiveTab == t.id
                                    ? 'selected ant-tabs-tab-active'
                                    : ''
                            ].join(' ')}
                        >
                            <div role="tab" aria-selected="true" className="ant-tabs-tab-btn" tabIndex="0" id="rc-tabs-1-tab-risks" aria-controls="rc-tabs-1-panel-risks">{t.title}</div>

                        </li>
                    );
                })}
            </ul>
            <div className="content h-100">
                {children && isFunction(children) ? children(effectiveTab, setSelectedTab) : null}
            </div>
        </Layout.Sider>
    </MaskableComponent >
}